import { store } from "../store";
import { BifrostBackendApi, BifrostBackendNestApi } from "../gateways/BifrostBackendApi";

const getApi = () => {
	const useNestOrderPaymentFlow =
		store.getters.featureToggles &&
		store.getters.featureToggles.useNestOrderPaymentFlow;
	return useNestOrderPaymentFlow ? BifrostBackendNestApi : BifrostBackendApi;
};

const ProductProvider = {
	async getProducts({productIds}) {
		if(!productIds || productIds.length === 0) {
			return [];
		}
		const res = await BifrostBackendNestApi.post(`/intusr/products`, {
			filterBy: {
				productIds
			}
		},
		{
			headers: {
				Authorizationidp: store.getters.applicationUserIdpToken
			}
		});
		return res.data;
	},

	findProductStatistics() {
		return BifrostBackendApi.get("/product-statistics", {
			headers: { Authorization: store.getters.jwtToken }
		});
	},

	async getEarliestPickupDate({productId, fromDate, shopId, tenantId}) {
		const queryParams = {
			tenantId,
			fromDate: fromDate.toISOString()
		};

		if (shopId) {
			queryParams.shopId = shopId;
		}

		const res = await getApi().get(`/product/earliest-pickup-date/${productId}`, {
			params: queryParams
		});

		return new Date(res.data);
	}
};

export default Object.freeze(ProductProvider);
